var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLanguage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_80_193)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 2H9.33325V5.33333H10.6666V3.33333H19.9999C20.3999 3.33333 20.6666 3.6 20.6666 4V11.3333C20.6666 11.7333 20.3999 12 19.9999 12H11.3333V16.6667H7.79992L5.33325 18.6V16.6667H3.33325C2.93325 16.6667 2.66659 16.4 2.66659 16V8.66667C2.66659 8.26667 2.93325 8 3.33325 8H11.9999V6.66667H3.33325C2.19992 6.66667 1.33325 7.53333 1.33325 8.66667V16C1.33325 17.1333 2.19992 18 3.33325 18H3.99992V21.4L8.19992 18H12.6666V13.3333H19.9999C21.1333 13.3333 21.9999 12.4667 21.9999 11.3333V4C21.9999 2.86667 21.1333 2 19.9999 2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.1333 15.2667H5.7333L6.1333 14.2H8.19997L8.59997 15.2667H10.2L7.9333 9.33337H6.3333L4.1333 15.2667ZM7.1333 11L7.79997 13.0667H6.46663L7.1333 11Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 11.3333C14.0666 11.3333 15.0666 11.1333 15.9999 10.6667C16.9333 11.1333 17.9999 11.3333 18.6666 11.3333V10C18.6666 10 17.9999 10 17.2666 9.73333C18.0666 8.93333 18.6666 7.73333 18.6666 6V5.33333H16.6666V4H15.3333V5.33333H13.3333V6.66667H17.2666C17.1333 7.86667 16.5999 8.6 15.9999 9.06667C15.5999 8.73333 15.1999 8.26667 14.9333 7.66667H13.5333C13.7999 8.53333 14.1999 9.2 14.7333 9.73333C14.0666 10 13.4666 10 13.3333 10V11.3333Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_80_193"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguage);
export default __webpack_public_path__ + "static/media/language.d4534390e7b3cbec63ba52eb6633098b.svg";
export { ForwardRef as ReactComponent };